import React, { PureComponent } from 'react';

import Container from 'react-bootstrap/Container';
import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Row, Col } from 'react-bootstrap';
import SelectNazione from '../RegistrationForm/SelectNazione';
import SelectProvincia from '../RegistrationForm/SelectProvincia';
import Modal from 'react-bootstrap/Modal';


import Labels_en from '../labels_en';
import Labels_it from '../labels_it';

import CzGlobals from '../global';

import axios from 'axios';


class RegistrationPage2 extends PureComponent {

  Labels = null;
  nextPage = null;

  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
      fldCellulare: null,
      fldTelCasa: null,
      fldTelLavoro: null,
      fldEmail: null,
      fldPwd: null,
      fldPwd2: null, 
      showAlert: false,
      errorMessage: null
    };

    if (props.lang == "it") {
      this.Labels = Labels_it;
    } else {
      this.Labels = Labels_en;
    }

    this.nextPage = props.onNextPage;

    this.loadData();

  }

  loadData = () => {


    const formData = new FormData();

    var dati = {
      funzione: 'Carica'
    };

    var s = btoa(JSON.stringify(dati));

    formData.append('d', s);
    var me = this;
    const request = axios.post(CzGlobals.apisite + 'AJAXCliente.php', formData)
      .then(function (response) {
          var res = response.data;
          if (res.status=="OK") {
            me.setState({
              fldCellulare: res.tel_cell,
              fldTelCasa: res.tel_casa,
              fldTelLavoro: res.tel_lav,
              fldEmail: res.email,
              fldPwd: null,
              fldPwd2: null,
              showAlert: false,
              errorMessage: null
            });

            
          } else {
            return;
          }
      });




  }


  validateData = () => {

    var error = this.Labels.lbl_invalidField;
    var isErrorState = false;

    if (!this.state.fldEmail) {
      isErrorState = true;
      error += this.Labels.lbl_Email + ",";
    }



    if (isErrorState) {
      this.setState({ showAlert: true, errorMessage: error });
      return;
    }


    const formData = new FormData();

    var dati = {
      funzione: 'pagina2',
      id_cliente: CzGlobals.id_cliente, 
      tel_cell: this.state.fldCellulare,
      tel_casa: this.state.fldTelCasa,
      tel_lav: this.state.fldTelLavoro,
      email: this.state.fldEmail,
    };

    var s = btoa(JSON.stringify(dati));

    formData.append('d', s);
    var me = this;
    const request = axios.post(CzGlobals.apisite + 'AJAXCliente.php', formData)
      .then(function (response) {
          var res = response.data;
          if (res.status=="OK") {
            me.nextPage();
          } else {
            me.setState({ showAlert: true, errorMessage: res.descrizione });
            return;
          }
      });


  }

  handleCloseAlert = () => {
    this.setState({ showAlert: false });
  }

  componentWillMount = () => {
    console.log('RegistrationPage1 will mount');
  }

  componentDidMount = () => {

   

    console.log('RegistrationPage1 mounted');
  }

  componentWillReceiveProps = (nextProps) => {
    console.log('RegistrationPage1 will receive props', nextProps);
  }

  componentWillUpdate = (nextProps, nextState) => {
    console.log('RegistrationPage1 will update', nextProps, nextState);
  }

  componentDidUpdate = () => {
    console.log('RegistrationPage1 did update');
  }

  componentWillUnmount = () => {
    console.log('RegistrationPage1 will unmount');
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong.</h1>;
    }
    return (
      <div className="RegistrationPage2Wrapper">
        <Card>
          <Card.Body>



            <Form>

              <Form.Row>
                <Form.Group as={Col} controlId="formGridTelCell">
                  <Form.Label><b>{this.Labels.lbl_Cellulare}</b></Form.Label>
                  <Form.Control placeholder="" value={this.state.fldCellulare} onChange={e => this.setState({ fldCellulare: e.target.value })} />
                </Form.Group>
                <Form.Group as={Col} controlId="formGridTelHome">
                  <Form.Label><b>{this.Labels.lbl_TelCasa}</b></Form.Label>
                  <Form.Control value={this.state.fldTelCasa} onChange={e => this.setState({ fldTelCasa: e.target.value })} />
                </Form.Group>
                <Form.Group as={Col} controlId="formGridTelWork">
                  <Form.Label><b>{this.Labels.lbl_TelLavoro}</b></Form.Label>
                  <Form.Control value={this.state.fldTelLavoro} onChange={e => this.setState({ fldTelLavoro: e.target.value })} />
                </Form.Group>
              </Form.Row>

              <Form.Row>
                <Form.Group as={Col} controlId="formGridEmail">
                  <Form.Label><b>{this.Labels.lbl_Email}</b></Form.Label>
                  <Form.Control type="email" value={this.state.fldEmail} onChange={e => this.setState({ fldEmail: e.target.value })} />
                  <Form.Text className="text-muted">
                  {this.Labels.lbl_email_msg}
                  </Form.Text>
                </Form.Group>
                <Form.Group as={Col} controlId="formGridTelHome">
                  <Form.Label><b>{this.Labels.lbl_Password}</b></Form.Label>
                  <Form.Control type="password" value={this.state.fldPwd} onChange={e => this.setState({ fldPwd: e.target.value })} />
                </Form.Group>
                <Form.Group as={Col} controlId="formGridTelWork">
                  <Form.Label><b>{this.Labels.lbl_Password2}</b></Form.Label>
                  <Form.Control type="password" value={this.state.fldPwd2} onChange={e => this.setState({ fldPwd2: e.target.value })} />
                </Form.Group>
              </Form.Row>


              <Button variant="primary" type="button" onClick={this.validateData}>
                {this.Labels.lbl_VaiAPagina2}
              </Button>

            </Form>

          </Card.Body>
        </Card>

        <Modal
          show={this.state.showAlert}
          onHide={this.handleCloseAlert} 
          //  backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.Labels.lbl_titoloMsgErrore}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.errorMessage}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseAlert}>
              Close
          </Button>
            <Button variant="primary">Understood</Button>
          </Modal.Footer>
        </Modal>

      </div >
    );
  }
}

RegistrationPage2.propTypes = {
  // bla: PropTypes.string,
};

RegistrationPage2.defaultProps = {
  // bla: 'test',
};

export default RegistrationPage2;
